import base from './base.repository';

export default {
    ...base,
    getMenuOptions(filters, page){
        const params = {...filters, page: page};
        this.get(`menu-options${this.querify(params)}`);
        return this;
    },
    getAllMenus(){
        this.get(`menu-options/all-menus`);
        return this;
    },
    saveMenuOption(payload){
        this.post('menu-options', payload);
        return this;
    },
    deleteMenuOption(id){
        this.delete(`menu-options/${id}`);
        return this;
    },
    getProfileMenuOptions(filters, page){
        const params = {...filters, page: page};
        this.get(`profile-menu-options${this.querify(params)}`);
        return this;
    },
    getPositionMenuOptions(filters, page){
        const params = {...filters, page: page};
        this.get(`position-menu-options${this.querify(params)}`);
        return this;
    }, 
    saveProfileMenuOption(payload){
        this.post('profile-menu-options', payload);
        return this;
    },
    savePositionMenuOption(payload){
        this.post('position-menu-options', payload);
        return this;
    },
    deletePositionMenuOption(id){
        this.delete(`position-menu-options/${id}`);
        return this;
    },
    deleteProfileMenuOption(id){
        this.delete(`profile-menu-options/${id}`);
        return this;
    },
}